export default {
  methods: {
    async validateForm() {
      const { isValid, errors } = await this.$refs.observer.validateWithInfo()
      const keys = Object.keys(errors)

      if (!isValid) {
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]

          const error = errors[key]
          if (error.length > 0) {
            this.formError = error[0]
            break
          }
        }
        return false
      }

      return true
    },
  },
}
